/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import gridConfig from '../../common/tableConfig/gridConfig'
import questionConfig, { convertColumndef, convertRowData } from '../../common/tableConfig/studentQuestionAnalyisConfig';
import tableStyle from '../../component/common/style/index.scss';
import style from '../../styles.module.scss';
import { sortByKey } from "../../common/utils";

export default class IsBlind extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            coloumnDef: [],
            rowData: [],
            icons: props.questionConfig.icons,
            height: props.height,
            isColorblind: props.isColorblind,
            questionConfig: props.questionConfig,
            isDataExist: props.isDataExist,
            colorBlindview: props.colorBlindview,
            defaultColDef: gridConfig.defaultColDef
        };
    }
    componentDidMount() {

        this.generateGridConfig(this.state.questionConfig, this.state.isColorblind)
    }
    
    componentDidUpdate() {
        this.props.updateExportData({ type: "question_analysis", rowData: { pinnedTopRow: this.state.pinnedTopRow, rowsArray:this.state.rowData}, columnDefs: this.state.coloumnDef});              
    }
    
    generateGridConfig(questionConfig, isColorblind) {

        let columndef = convertColumndef(true, questionConfig);
        let rowData = convertRowData(questionConfig);
        let height = 200 + (parseInt(rowData.rowData.length) + parseInt(rowData.pinnedData.length)) * 100;
        this.setState({ rowData: rowData.rowData, pinnedTopRow: rowData.pinnedData, coloumnDef: columndef, height: height });
        this.props.updateExportData({ type: "question_analysis", rowData: { pinnedTopRow: this.state.pinnedTopRow, rowsArray:this.state.rowData}, columnDefs: this.state.coloumnDef});              
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.refreshCells(params);
        this.gridApi.setColumnDefs(this.state.coloumnDef);
    };
    
    onSortChanged = (params) => {
        let sortModel = params.api.getSortModel();
        let sortedRowData = sortByKey(this.state.rowData, sortModel[0]["colId"]);
        this.setState({ rowData: sortedRowData });
    }

    render() {
        return (
            <div>
                <div className="col">
                    <div className="row contentFilter">
                        <div style={{ flex: 1 }}></div>
                        {this.state.isDataExist ? (
                            <div className={['checkboxCls', style.customCheckbox].join(" ")}>
                                <input type="checkbox" id="colorblind" className="checkbox" value={this.state.isColorblind} onChange={this.state.colorBlindview} checked={this.state.isColorblind} />
                                <label for="colorblind">Enable colourblind-friendly mode</label>
                            </div>

                        ) : (<div className="checkboxCls">

                        </div>)}


                    </div>

                    <div className="row">
                        <div className="labelMarkleft checkboxCls" style={{padding: 0, display: 'flex', flexDirection: 'row', marginRight: 20}}>

                            <i className={[tableStyle.lowMarkIcon, 'iconAverage'].join(' ')}></i>
                            <p> Mark is low</p>
                        </div>

                        <div className="labelMarkRight checkboxCls" style={{padding: 0, display: 'flex', flexDirection: 'row'}}>
                            <i className={[tableStyle.midrangeMarkIcon, 'iconAverage'].join(' ')}></i>
                            <p> Mark is mid-range</p>
                        </div>
                    </div>
                </div>
                <div className="ag-theme-alpine" id="blind" style={{ height: '', width: 'auto' }}>
                    <AgGridReact tooltipShowDelay={0}
                        columnDefs={this.state.coloumnDef}
                        rowData={this.state.rowData}
                        icons={this.state.icons}
                        defaultColDef={this.state.defaultColDef}
                        onGridReady={this.onGridReady}                      
                        pinnedTopRowData={this.state.pinnedTopRow}
                        domLayout="autoHeight"  
                        onColumnResized={this.props.onColumnResized}
                    >
                    </AgGridReact>
                </div>
            </div>
        )
    }
}